interface TypographyProps {
    children: React.ReactNode;
    className?: string;
}

export const BodyXLBold = ({ children, className = '' }: TypographyProps) => {
    return (
        <p className={`font-outfit text-xl font-extrabold leading-6 ${className}`}>
            {children}
        </p>
    );
};
